import React, { useState } from "react";
import { Button } from "antd";
import Sidebar from "./Sidebar";
import "./styles/Profile.css";
import { useAuth } from "../context/AuthContext";
import { useGmailAccounts } from "../hooks/useGmailAccounts";

const defaultAvatar = `${process.env.PUBLIC_URL}/logo192.png`;

const Profile = () => {
  const { user: authUser } = useAuth();
  const { data: gmailAccountsData } = useGmailAccounts(authUser?.uid, { enabled: !!authUser });
  const profileName = authUser?.displayName || "";
  const primaryConnectedEmail = gmailAccountsData?.accounts?.[0]?.email || "";
  const profileEmail = gmailAccountsData?.mainEmail || authUser?.email || primaryConnectedEmail;

  // Keep local state only for non-auth profile UI state.
  const [user, setUser] = useState({
    profilePic: defaultAvatar,
    isEditing: false,
  });

  // ✅ PRESERVED: All AFC handlers (no changes)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setUser((prevUser) => ({ ...prevUser, profilePic: imageUrl }));
    }
  };

  const toggleEdit = () => {
    setUser((prevUser) => ({ ...prevUser, isEditing: !prevUser.isEditing }));
  };

  const handleSave = () => {
    // Later: Save this to Firebase when backend is ready
    setUser((prevUser) => ({ ...prevUser, isEditing: false }));
  };

  // ✅ VISUAL UPDATE: MEO structure with scoped classes
  return (
    <div className="afc-profile dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="dashboard-header">
          <h2 className="dashboard-logo">Profile</h2>
        </div>
        <div className="dashboard-content profile-page">
          <h3 className="profile-title">User Profile</h3>
          <div className="profile-info">
            {!user.isEditing ? (
              <>
                <div className="profile-picture">
                  <img
                    src={user.profilePic}
                    alt="Profile"
                    className="profile-img"
                    onError={(e) => { e.currentTarget.src = defaultAvatar; }}
                  />
                </div>
                <p><strong>Username:</strong> {profileName || "Not set"}</p>
                <p><strong>Email:</strong> {profileEmail || "Not available"}</p>
                <Button className="update-profile-btn" onClick={toggleEdit}>
                  Edit Profile
                </Button>
              </>
            ) : (
              <div className="profile-edit-form">
                <div className="profile-picture">
                  <img
                    src={user.profilePic}
                    alt="Profile"
                    className="profile-img"
                    onError={(e) => { e.currentTarget.src = defaultAvatar; }}
                  />
                  <input 
                    type="file" 
                    id="fileInput" 
                    onChange={handleFileChange} 
                    style={{ display: 'none' }} 
                  />
                  <label htmlFor="fileInput" className="upload-btn">Change Photo</label>
                </div>
                <div className="form-field">
                  <label>Username</label>
                  <input type="text" name="name" value={profileName || "Not set"} readOnly />
                </div>
                <div className="form-field">
                  <label>Email</label>
                  <input type="email" name="email" value={profileEmail || ""} readOnly />
                </div>
                <div className="form-actions">
                  <Button type="primary" onClick={handleSave}>Save Changes</Button>
                  <Button onClick={toggleEdit} style={{ marginLeft: '10px' }}>Cancel</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;